const ActionType = {
  Auth: {
    SIGNOUT_REQUEST: '',
    SIGNOUT_SUCCESS: '',
    SIGNOUT_FAILURE: '',

    CURRENT_CREDENTIALS_REQUEST: '',
    CURRENT_CREDENTIALS_SUCCESS: '',
    CURRENT_CREDENTIALS_FAILURE: '',

    CLOSE_ERROR: '',

    CURRENT_SESSION_REQUEST: '',
    CURRENT_SESSION_SUCCESS: '',
    CURRENT_SESSION_FAILURE: '',

    REFRESH_TOKEN_REQUEST: '',
    REFRESH_TOKEN_SUCCESS: '',
    REFRESH_TOKEN_FAILURE: '',

    // SET_AUTH_STATE: '',
    // SET_USER: '',
  },
  Schemas: {
    LOAD_CREATE_SCHEMAS_REQUESTS: '',
    LOAD_CREATE_SCHEMAS_SUCCESS: '',
    LOAD_CREATE_SCHEMAS_FAILURE: '',

    REQUEST: '',
    SUCCESS: '',
    FAILURE: '',
  },
  S3_MANAGER: {
    POST_SUCCESS: '',
    POST_REQUEST: '',
    POST_FAILURE: '',
    LIST_REQUEST: '',
    LIST_SUCCESS: '',
    LIST_FAILURE: '',
    DELETE_SUCCESS: '',
    DELETE_REQUEST: '',
    DELETE_FAILURE: '',
    DELETE_FOLDER_SUCCESS: '',
    DELETE_FOLDER_REQUEST: '',
    DELETE_FOLDER_FAILURE: '',
    MOVE_SUCCESS: '',
    MOVE_REQUEST: '',
    MOVE_FAILURE: '',
  },
  PAYMENTS_MANAGER: {
    CLIENT_TOKEN_READ_REQUEST: '',
    CLIENT_TOKEN_READ_SUCCESS: '',
    CLIENT_TOKEN_READ_FAILURE: '',
    ADD_PAYMENT_METHOD_REQUEST: '',
    ADD_PAYMENT_METHOD_SUCCESS: '',
    ADD_PAYMENT_METHOD_FAILURE: '',
    PLANS_READ_REQUEST: '',
    PLANS_READ_SUCCESS: '',
    PLANS_READ_FAILURE: '',
    SUBSCRIPTION_READ_REQUEST: '',
    SUBSCRIPTION_READ_SUCCESS: '',
    SUBSCRIPTION_READ_FAILURE: '',
    CREATE_SUBSCRIPTION_REQUEST: '',
    CREATE_SUBSCRIPTION_SUCCESS: '',
    CREATE_SUBSCRIPTION_FAILURE: '',
    UPDATE_SUBSCRIPTION_REQUEST: '',
    UPDATE_SUBSCRIPTION_SUCCESS: '',
    UPDATE_SUBSCRIPTION_FAILURE: '',
    CUSTOMER_READ_REQUEST: '',
    CUSTOMER_READ_SUCCESS: '',
    CUSTOMER_READ_FAILURE: '',
    OPEN_PAYMENTS_MODAL: '',
    CREATE_ADDRESS_REQUEST: '',
    CREATE_ADDRESS_SUCCESS: '',
    CREATE_ADDRESS_FAILURE: '',
    UPDATE_ADDRESS_REQUEST: '',
    UPDATE_ADDRESS_SUCCESS: '',
    UPDATE_ADDRESS_FAILURE: '',
  },
  Data: {
    LIST_REQUEST: '',
    LIST_SUCCESS: '',
    LIST_FAILURE: '',

    CREATE_REQUEST: '',
    CREATE_SUCCESS: '',
    CREATE_FAILURE: '',

    READ_REQUEST: '',
    READ_SUCCESS: '',
    READ_FAILURE: '',

    UPDATE_REQUEST: '',
    UPDATE_SUCCESS: '',
    UPDATE_FAILURE: '',

    DELETE_REQUEST: '',
    DELETE_SUCCESS: '',
    DELETE_FAILURE: '',

    VALIDATION_SUCCESS: '',
    VALIDATION_FAILURE: '',
  },
  Campaign: {
    TOGGLE_FORM_DATA_PANEL: '',
    RECEIVE_CAMPAIGN: '',
    CHANGE_NEW_STAGE_NAME: '',
    ADD_STAGE: '',
    ADD_STAGE_SUCCESS: '',
    CHANGE_STAGE_NAME: '',
    TOGGLE_FUNNEL_CALENDAR_VIEW: '',
    TOGGLE_CALENDAR_LIST_VIEW: '',
    TOGGLE_DATE_RANGE: '',
    CHANGE_FIELD: '',
    ADD_NEW_TASK_TO_CAMPAIGN: '',
    ADD_TASK_TO_CAMPAIGN: '',
    ADD_OR_EDIT_EVENT_GOAL: '',
    ADD_EVENT_GOAL_TO_CAMPAIGN: '',
    EXPAND_FUNNEL_STAGE: '',
    TOGGLE_TASK_MODAL: '',

    MOVE_STAGE_TASK: '',
    MOVE_STAGE: '',
    DELETE_STAGE: '',
    REMOVE_EVENT_GOAL: '',
    REMOVE_NEW_EVENT_GOAL: '',
    REMOVE_STAGE_TASK: '',

    UPDATE_STATUS_REQUEST: '',
    UPDATE_STATUS_SUCCESS: '',
    UPDATE_STATUS_FAILURE: '',

    CLICK_BOTTOM_NAVIGATION: '',
    TOGGLE_BOTTOM_NAV: '',

    LIST_CONTACTS_IN_STAGE_REQUEST: '',
    LIST_CONTACTS_IN_STAGE_SUCCESS: '',
    LIST_CONTACTS_IN_STAGE_FAILURE: '',

    CLICK_CONTACT_COUNT: '',
    INGEST_PREDICTION: '',

    SELECT_EVENT_GOAL: '',
    CHANGE_SUBENTITY: '',
    CHANGE_SUBENTITY_VALUE: '',
    CHANGE_OPERATOR: '',
    CHANGE_ENTITY: '',
    ADD_SUBCRITERIA: '',
    REMOVE_SUBCRITERIA: '',
    CHANGE_CUSTOM_FIELD: '',

    ADD_PLACEHOLDER_TASK: '',
    REPLACE_PLACEHOLDER_TASK: '',
    // MOVE_PLACEHOLDER_TASK: '',
    // REMOVE_PLACEHOLDER_TASK: '',
  },
  Contacts: {
    GET_REQUEST: '',
    GET_SUCCESS: '',
    GET_FAILURE: '',

    GET_ALL_REQUEST: '',
    GET_ALL_SUCCESS: '',
    GET_ALL_FAILURE: '',

    GET_ALL_WITH_EMAILS_REQUEST: '',
    GET_ALL_WITH_EMAILS_SUCCESS: '',
    GET_ALL_WITH_EMAILS_FAILURE: '',

    CREATE_REQUEST: '',
    CREATE_SUCCESS: '',
    CREATE_FAILURE: '',

    UPDATE_REQUEST: '',
    UPDATE_SUCCESS: '',
    UPDATE_FAILURE: '',

    DELETE_REQUEST: '',
    DELETE_SUCCESS: '',
    DELETE_FAILURE: '',

    OPEN_ADD_DETAILS_MODAL: '',
    CLOSE_ADD_DETAILS_MODAL: '',
    TOGGLE_ADD_DETAILS_MODAL: '',

    OPEN_BULK_UPLOAD_DIALOG: '',
    CLOSE_BULK_UPLOAD_DIALOG: '',
    TOGGLE_BULK_UPLOAD_DIALOG: '',

    HANDLE_DEFAULT_FIELD_CHANGE: '',
    HANDLE_CUSTOM_ATTRIBUTE_CHANGE: '',
    HANDLE_EMAIL_FIELD_CHANGE: '',
    RECEIVE_CONTACT: '',

    HANDLE_CHECKBOX_CHANGE: '',
    HANDLE_FIELD_MODAL_CHANGE: '',
    HANDLE_MULTIPLE_CHANGE: '',

    ADD_CUSTOM_FIELDS: '',

    GET_CUSTOM_ATTRIBUTES_REQUEST: '',
    GET_CUSTOM_ATTRIBUTES_SUCCESS: '',
    GET_CUSTOM_ATTRIBUTES_FAILURE: '',

    TOGGLE_CUSTOM_FIELD_HOVER: '',
    REMOVE_CUSTOM_ATTRIBUTE: '',

    BULK_UPLOAD_REQUEST: '',
    BULK_UPLOAD_SUCCESS: '',
    BULK_UPLOAD_FAILURE: '',
    BULK_UPLOAD_PROGRESS: '',

    OPEN_MULTI_MESSAGE_DIALOG: '',
    CLOSE_MULTI_MESSAGE_DIALOG: '',

    CREATE_GROUP: '',
    DELETE_GROUP: '',
    UPDATE_GROUP: '',

    OPEN_CREATE_OR_UPDATE_GROUP_DIALOG: '',
    CLOSE_CREATE_OR_UPDATE_GROUP_DIALOG: '',
    HANDLE_GROUP_MODAL_FIELD_CHANGE: '',

    ADD_CONTACTS_TO_GROUP: '',
    REMOVE_CONTACTS_FROM_GROUP: '',

    TOGGLE_SELECTED_CONTACTS_MENU: '',

    SELECT_CONTACT: '',
    DESELECT_ALL_CONTACTS: '',
    OPEN_CREATE_GROUP_FROM_SELECTED_DIALOG: '',
    CLOSE_CREATE_GROUP_FROM_SELECTED_DIALOG: '',
    HANDLE_CREATE_GROUP_FROM_SELECTED_FIELD_CHANGE: '',
    CREATE_GROUP_FROM_SELECTED: '',
    GROUP_SELECT_VALUE_CHANGE: '',

    GET_ALL_GROUPS_REQUEST: '',
    GET_ALL_GROUPS_SUCCESS: '',
    GET_ALL_GROUPS_FAILURE: '',

    GET_GROUP_REQUEST: '',
    GET_GROUP_SUCCESS: '',
    GET_GROUP_FAILURE: '',

    CREATE_GROUP_REQUEST: '',
    CREATE_GROUP_SUCCESS: '',
    CREATE_GROUP_FAILURE: '',

    ADD_CONTACTS_TO_GROUP_REQUEST: '',
    ADD_CONTACTS_TO_GROUP_SUCCESS: '',
    ADD_CONTACTS_TO_GROUP_FAILURE: '',

    REMOVE_CONTACTS_FROM_GROUP_REQUEST: '',
    REMOVE_CONTACTS_FROM_GROUP_SUCCESS: '',
    REMOVE_CONTACTS_FROM_GROUP_FAILURE: '',

    RENAME_GROUP_REQUEST: '',
    RENAME_GROUP_SUCCESS: '',
    RENAME_GROUP_FAILURE: '',

    DELETE_GROUP_REQUEST: '',
    DELETE_GROUP_SUCCESS: '',
    DELETE_GROUP_FAILURE: '',

    OPEN_RENAME_GROUP_DIALOG: '',
    CLOSE_RENAME_GROUP_DIALOG: '',
    HANDLE_RENAME_GROUP_FIELD_CHANGE: '',
    RECEIVE_GROUP: '',

    TOGGLE_BOTTOM_NAV: '',
    TOGGLE_BOTTOM_MENU: '',
    HANDLE_ADD_FIELD: '',
    HANDLE_FIELD_CHANGE: '',

    HANDLE_GROUP_CHANGE: '',
    HANDLE_GROUP_SUGGESTION_CLICK: '',

    CREATE_TASK_WITH_CONTACT: '',

    TOGGLE_OPT_OUT_REQUEST: '',
    TOGGLE_OPT_OUT_SUCCESS: '',
    TOGGLE_OPT_OUT_FAILURE: '',

    OPT_OUT_REQUEST: '',
    OPT_OUT_SUCCESS: '',
    OPT_OUT_FAILURE: '',

    INGEST_PREDICTION: '',

    VALIDATION_SUCCESS: '',
    VALIDATION_FAILURE: '',
    SCHEMA_REQUEST: '',
    SCHEMA_SUCCESS: '',
    SCHEMA_FAILURE: '',

    TOGGLE_GROUP_DIALOG: '',
  },

  Email: {
    CLICK_CONTACT_TO_EMAIL: '',
    HANDLE_SUBJECT_CHANGE: '',
    HANDLE_TO_CHANGE: '',
    HANDLE_BODY_CHANGE: '',

    SEND_REQUEST: '',
    SEND_SUCCESS: '',
    SEND_FAILURE: '',

    SAVE_REQUEST: '',
    SAVE_SUCCESS: '',
    SAVE_FAILURE: '',

    Templates: {
      CREATE_REQUEST: '',
      CREATE_SUCCESS: '',
      CREATE_FAILURE: '',

      UPDATE_REQUEST: '',
      UPDATE_SUCCESS: '',
      UPDATE_FAILURE: '',

      LIST_REQUEST: '',
      LIST_SUCCESS: '',
      LIST_FAILURE: '',

      DELETE_REQUEST: '',
      DELETE_SUCCESS: '',
      DELETE_FAILURE: '',

      SCHEDULE_REQUEST: '',
      SCHEDULE_SUCCESS: '',
      SCHEDULE_FAILURE: '',

      READ_REQUEST: '',
      READ_SUCCESS: '',
      READ_FAILURE: '',

      LIST_SCHEDULED_REQUEST: '',
      LIST_SCHEDULED_SUCCESS: '',
      LIST_SCHEDULED_FAILURE: '',

      CANCEL_SCHEDULED_REQUEST: '',
      CANCEL_SCHEDULED_SUCCESS: '',
      CANCEL_SCHEDULED_FAILURE: '',

      RECEIVE_TEMPLATE: '',
      HANDLE_TEMPLATE_NAME_CHANGE: '',

      READ_FOOTER_REQUEST: '',
      READ_FOOTER_SUCCESS: '',
      READ_FOOTER_FAILURE: '',

      SELECT_EMAIL_CARD: '',
      SELECT_THEME: '',
      TOGGLE_SNIPPETS_PANEL: '',
      PASTE_SNIPPET: '',
      TOGGLE_VARIABLES_PANEL: '',
      CLICK_VARIABLES_PANEL_TAB: '',
      DEFAULT_VALUE_CHANGE: '',
      PASTE_TAG: '',
      EMAIL_EDITOR_CHANGE: '',
      HANDLE_SUBJECT_CHANGE: '',
      BACK_BUTTON: '',
      CODE_EDITOR_CHANGE: '',
      CLICK_CODE_BUTTON: '',
      CLICK_BOTTOM_NAVIGATION: '',
      TOGGLE_COLLAPSE: '',
      SET_SECTIONS: '',
      SELECT_SECTION: '',
      CLICK_SECTION: '',
      SET_BACKGROUND: '',
      SET_TEXT_ALIGN: '',
      SET_IMAGE: '',
      SET_IMAGE_URL: '',
      SET_IMAGE_DIMENSION: '',
      SET_IMAGE_SIZE: '',
      REMOVE_SECTION: '',
      CHANGE_FIELD_VALUES: '',
      SAVE_VALUES: '',
      CHANGE_TEMPLATE_ID: '',
      READ_THEME_FROM_HTML: '',
      TOGGLE_DEFAULT_VALUES_MODAL: '',

      SELECT_TEMPLATE_TYPE: '',
    },
  },

  SmartNotes: {
    GET_ENTITIES_REQUEST: '',
    GET_ENTITIES_SUCCESS: '',
    GET_ENTITIES_FAILURE: '',

    FOCUS: '',
    BLUR: '',
  },
  PREDICTIONS: {
    GET_REQUEST: '',
    GET_SUCCESS: '',
    GET_FAILURE: '',
    CONSUME_PREDICTION: '',
    INGEST_PREDICTION: '',
  },
  LUIS: {
    GET_REQUEST: '',
    GET_SUCCESS: '',
    GET_FAILURE: '',
  },
  Onboarding: {
    READ_REQUEST: '',
    READ_SUCCESS: '',
    READ_FAILURE: '',
    TOGGLE_EXPANSION_PANEL: '',
  },
  SignupForm: {
    ADD_REQUEST: '',
    ADD_SUCCESS: '',
    ADD_FAILURE: '',

    LIST_REQUEST: '',
    LIST_SUCCESS: '',
    LIST_FAILURE: '',

    READ_REQUEST: '',
    READ_SUCCESS: '',
    READ_FAILURE: '',

    UPDATE_REQUEST: '',
    UPDATE_SUCCESS: '',
    UPDATE_FAILURE: '',

    DELETE_REQUEST: '',
    DELETE_FAILURE: '',
    DELETE_SUCCESS: '',

    SCHEMA_REQUEST: '',
    SCHEMA_SUCCESS: '',
    SCHEMA_FAILURE: '',

    VALIDATION_SUCCESS: '',
    VALIDATION_FAILURE: '',

    TOGGLE_VIEW: '',
    TOGGLE_SORT_MENU: '',
    TOGGLE_EXPAND_PANEL: '',
    CHANGE_SORT: '',
    SELECT_FORM_TYPE: '',
    BACK_BUTTON: '',
    RECEIVE_FORM: '',
    HANDLE_GROUP_CHANGE: '',
    HANDLE_FORM_VIEW_SELECT: '',
    HANDLE_FORM_VALUE_CHANGE: '',
    HANDLE_FORM_FIELD_CHANGE: '',
    HANDLE_FORM_DRAG: '',
    FORM_FIELD_REQUIRED_CHANGE: '',
    HANDLE_GROUP_SUGGESTION_CLICK: '',
    TOGGLE_BOTTOM_NAV: '',
    CLOSE_SNACKBAR: '',
    TOGGLE_PREVIEW_RESPONSE_VIEW: '',
    TOGGLE_FORM_DATA_PANEL: '',
    TOGGLE_BOTTOM_MENU: '',
  },
  CustomForm: {
    ADD_SECTION: '',
    CHANGE_SECTION_VALUE: '',

    TOGGLE_VIEW: '',
    TOGGLE_SORT_MENU: '',
    TOGGLE_EXPAND_PANEL: '',
    CHANGE_SORT: '',
    SELECT_FORM_TYPE: '',
    BACK_BUTTON: '',
    RECEIVE_FORM: '',
    HANDLE_GROUP_CHANGE: '',
    HANDLE_FORM_VIEW_SELECT: '',
    HANDLE_FORM_VALUE_CHANGE: '',
    HANDLE_FORM_FIELD_CHANGE: '',
    HANDLE_FORM_DRAG: '',
    FORM_FIELD_REQUIRED_CHANGE: '',
    HANDLE_GROUP_SUGGESTION_CLICK: '',
    TOGGLE_BOTTOM_NAV: '',
    CLOSE_SNACKBAR: '',
    TOGGLE_PREVIEW_RESPONSE_VIEW: '',
    TOGGLE_FORM_DATA_PANEL: '',
    TOGGLE_BOTTOM_MENU: '',

    MOVE_SECTION: '',
    EDIT_SECTION: '',
    CANCEL_EDIT: '',
    DELETE_SECTION: '',
    DRAG_PILL: '',
    GO_TO_PAGE: '',
    SELECT_SECTION: '',
    CHANGE_SECTION: '',
    HANDLE_SECTION_VALUE_CHANGE: '',
    HANDLE_SECTION_FIELD_CHECKBOX_CHANGE: '',
    HANDLE_MULTI_OPTION_CHANGE: '',
    MOVE_TO_PAGE: '',
    TOGGLE_CUSTOM_LANDING_PAGE: '',
    // READ_NEXT_ANALYTICS_PAGE: '',
    PREV_ANALYTICS_PAGE: '',
    NEXT_ANALYTICS_PAGE: '',
  },
  AccountSettings: {
    LIST_REQUEST: '',
    LIST_SUCCESS: '',
    LIST_FAILURE: '',

    UPDATE_REQUEST: '',
    UPDATE_SUCCESS: '',
    UPDATE_FAILURE: '',
    LIST_PREFERENCES_REQUEST: '',
    LIST_PREFERENCES_SUCCESS: '',
    LIST_PREFERENCES_FAILURE: '',

    UPDATE_PREFERENCES_REQUEST: '',
    UPDATE_PREFERENCES_SUCCESS: '',
    UPDATE_PREFERENCES_FAILURE: '',
  },
  SMS: {
    CLICK_CONTACT_TO_TEXT: '',
    HANDLE_TO_CHANGE: '',
    HANDLE_BODY_CHANGE: '',

    SEND_REQUEST: '',
    SEND_SUCCESS: '',
    SEND_FAILURE: '',
  },
  Tasks: {
    LIST_TYPES_REQUEST: '',
    LIST_TYPES_SUCCESS: '',
    LIST_TYPES_FAILURE: '',

    LIST_REQUEST: '',
    LIST_SUCCESS: '',
    LIST_FAILURE: '',

    ADD_REQUEST: '',
    ADD_SUCCESS: '',
    ADD_FAILURE: '',

    UPDATE_REQUEST: '',
    UPDATE_SUCCESS: '',
    UPDATE_FAILURE: '',

    READ_REQUEST: '',
    READ_SUCCESS: '',
    READ_FAILURE: '',

    DELETE_REQUEST: '',
    DELETE_SUCCESS: '',
    DELETE_FAILURE: '',

    HANDLE_FIELD_CHANGE: '',
    SMART_TASK_FOCUS: '',
    SMART_TASK_BLUR: '',
    HANDLE_CALENDAR_CHANGE: '',
    OPEN_TEMPLATE_SELECT: '',
    CLOSE_TEMPLATE_SELECT: '',
    HANDLE_TEMPLATE_CHANGE: '',
    HANDLE_MULTI_CHANGE: '',
    HANDLE_MULTI_CHANGE_GROUP: '',
    HANDLE_MULTI_CHANGE_CONTACT: '',
    RECEIVE_TASK: '',
    HANDLE_TEMPLATE_EDIT: '',
    CLOSE_DATE_ERROR: '',
    SELECT_EMAIL_CARD: '',
    BACK_BUTTON: '',
    HANDLE_THEME_CHANGE: '',
    TOGGLE_VIEW: '',
    MANUALLY_TOGGLE_VIEW: '',
    HANDLE_TEMPLATE_NAME_CHANGE: '',
    HANDLE_SUBJECT_CHANGE: '',
    EMAIL_EDITOR_CHANGE: '',
    TOGGLE_SNIPPETS_PANEL: '',
    TOGGLE_VARIABLES_PANEL: '',
    CLICK_CODE_BUTTON: '',
    CODE_EDITOR_CHANGE: '',
    PASTE_TAG: '',
    PASTE_SNIPPET: '',
    CLICK_VARIABLES_PANEL_TAB: '',
    ADD_SMS: '',
    TYPE_SMS: '',
    DEFAULT_VALUE_CHANGE: '',
    CHANGE_SORT: '',
    TOGGLE_GENERAL_PANEL: '',

    SCHEMA_REQUEST: '',
    SCHEMA_SUCCESS: '',
    SCHEMA_FAILURE: '',

    VALIDATION_SUCCESS: '',
    VALIDATION_FAILURE: '',

    CLOSE_SNACKBAR: '',

    CHANGE_AUTOMATION_TYPE: '',
    TOGGLE_SPLIT_FORM: '',
    SELECT_CAMPAIGN: '',
    SELECT_STAGE: '',

    TOGGLE_ACTION_TYPE_PANEL: '',

    SELECT_GROUP: '',
    SELECT_GROUP_TO_ADD_TO: '',
    SELECT_GROUP_TO_REMOVE_FROM: '',
    SELECT_CONTACTS_FOR_GROUP: '',
    SET_DELAY: '',
    SET_WHEN_TO_TRIGGER: '',

    CLICK_BOTTOM_NAVIGATION: '',
    TOGGLE_BOTTOM_NAV: '',
    CHANGE_DELAY_UNIT: '',

    SCHEDULER_MOUNTED: '',
    SELECT_FROM_NUMBER: '',
    TOGGLE_MANAGE_PHONES_MODAL: '',
    SELECT_ASSIGNMENT_POOL: '',
    SET_MEDIA_URL: '',
    SELECT_FROM_EMAIL: '',
    CHANGE_FROM_NAME: '',
    SELECT_CAMPAIGN_TO_REMOVE_CONTACT_FROM: '',
    SELECT_ENDPOINT: '',
  },
  View: {
    TOGGLE_DRAWER: '',
    CLOSE_DRAWER: '',
    OPEN_DRAWER: '',
    TOGGLE_DELETE_DIALOG: '',
    TOGGLE_ERRORS_DIALOG: '',
    CHANGE_SORT_BY: '',
    CHANGE_SORT_ORDER: '',
    SEARCH: '',
    SET_EXPANSION_PANELS: '',
    TOGGLE_MULTI_EXPANSION_PANEL: '',
    UPDATE_EXPANSION_PANELS: '',
    CLOSE_ERROR: '',
    STEPPER_INCREASE: '',
    STEPPER_DECREASE: '',
    STEPPER_GO_TO: '',
    OPEN_SNACKBAR: '',
    CLOSE_SNACKBAR: '',
    UPDATE_COUNT: '',
    SELECT_USER_ASSIGNMENT: '',
    OPEN_PROFILE_DIALOG: '',
    OPEN_IMAGE_DIALOG: '',
    OPEN_DELETE_PERSONAL_DATA_DIALOG: '',
    OPEN_LOADING_DIALOG: '',
    TOGGLE_DIALOG: '',
    TOGGLE_ADVANCED_SEARCH_CHECKBOX: '',
  },
  PhoneNumbers: {
    TOGGLE_ACQUIRE_NUMBER_DISPLAY: '',
    CHANGE_AREA_CODE: '',
    SEARCH_AVAILABLE_PHONE_NUMBERS_REQUEST: '',
    SEARCH_AVAILABLE_PHONE_NUMBERS_SUCCESS: '',
    SEARCH_AVAILABLE_PHONE_NUMBERS_FAILURE: '',
    SELECT_DEFAULT_PHONE_NUMBER: '',
    SELECT_NEW_PHONE_NUMBER: '',
    SELECT_USE_CASE: '',
  },
  Inbox: {
    SELECT_CONVERSATION: '',
    TOGGLE_CONTACT_VIEW_PANEL: '',
    TOGGLE_THREAD_VIEW: '',
    TOGGLE_CHAT_SEARCH: '',
    HANDLE_SEARCH_OPTIONS_CHANGE: '',
    SEARCH_CONVERSATIONS_LIST: '',
    CONTACT_SEARCH: '',
    SELECT_CONTACT: '',
    READ_EMAIL_REQUEST: '',
    READ_EMAIL_SUCCESS: '',
    READ_EMAIL_FAILURE: '',
    TOGGLE_EMAIL_DIALOG: '',
    CHANGE_MESSAGE_TYPE: '',
    CHANGE_TO: '',
    SEND_EMAIL: '',
    SEND_SMS: '',
    SELECT_NEW_CONVERSATION: '',
    LIST_REQUEST: '',
    LIST_SUCCESS: '',
    CALL: '',
    SELECT_FROM_NUMBER: '',
    REPLY_TO_EMAIL: '',
    CLEAR_FILTERS: '',
    SELECT_FROM_EMAIL: '',
    CHANGE_FROM_NAME: '',
    TOGGLE_MESSAGE_MENU: '',
    FILTER_CONVERSATIONS_LIST: '',
    FILTER_USER_CONVERSATIONS_LIST: '',
  },
  Editor: {
    CHANGE: '',
  },
  Acknowledgements: {
    TOGGLE_MODAL: '',
    CREATE_SUCCESS: '',
    CREATE_REQUEST: '',
    CREATE_FAILURE: '',
  },
  VOICE: {
    GET_TOKEN_SUCCESS: '',
    GET_TOKEN_REQUEST: '',
    GET_TOKEN_FAILURE: '',

    GET_TOKEN_SCHEMA_REQUEST: '',
    GET_TOKEN_SCHEMA_SUCCESS: '',
    GET_TOKEN_SCHEMA_FAILURE: '',
  },
  Phone: {
    TOGGLE_MODAL: '',
    SET_STATE: '',
  },
  Users: {
    TOGGLE_DIALOG: '',
    TOGGLE_STATE: '',
    SELECT_USER: '',
  },
  RoundRobin: {
    TOGGLE_DIALOG: '',
    SELECT_USER_TO_ADD: '',
    UPDATE_CONTACT_WITH_USER: '',
  },
  LogoManagement: {
    TOGGLE_DIALOG: '',
    CHANGE_LOGO_URL: '',
  },
  VastGPT: {
    ADD_MESSAGE: '',
    CLEAR_MESSAGES: '',
    REPLACE_MESSAGE: '',
    SET_LOADING: '',
    ADD_RELEVANT_INFO: '',
    CLEAR_RELEVANT_INFO: '',
    SET_RELEVANT_INFO_EXPANDED: '',
    SET_LOADING_INBOX: '',
    ADD_RELEVANT_INFO_INBOX: '',
    CLEAR_RELEVANT_INFO_INBOX: '',
  },
}

function stringify(object, str = '') {
  const dup = object

  Object.keys(dup).forEach(nextLevel => {
    if (typeof dup[nextLevel] === 'string') {
      dup[nextLevel] = `${str}.${nextLevel}`
    } else {
      let nextStr
      if (str === '') {
        nextStr = `${nextLevel}`
      } else {
        nextStr = `${str}.${nextLevel}`
      }

      stringify(dup[nextLevel], nextStr)
    }
  })

  return dup
}

export default stringify(ActionType)
